// T052: Create FeedPage component
// T067: Add compose button in header
// T015: Integrate QuickPost component (logged-in users only)

import { useState } from 'react'
import { Link } from 'react-router'
import { FeedList } from '@/components/feed/FeedList'
import { PostComposer } from '@/components/post/PostComposer'
import { QuickPostForm, FloatingActionButton } from '@/components/feed/QuickPost'
import { UserMenu } from '@/components/user/UserMenu'
import { NotificationMenu } from '@/components/notifications'
import { useAuthStore } from '@/stores/authStore'
import { Button } from '@/components/ui/button'
import { Plus, Search } from 'lucide-react'

export default function FeedPage() {
  const user = useAuthStore((state) => state.user)
  const [composerOpen, setComposerOpen] = useState(false)

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <header className="sticky top-0 z-10 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
        <div className="container flex h-16 items-center justify-between px-4">
          <h1 className="text-2xl font-bold">Fast Steemit</h1>

          <div className="flex items-center gap-2 sm:gap-4">
            <Button variant="ghost" size="icon" asChild>
              <Link to="/search">
                <Search className="h-5 w-5" />
              </Link>
            </Button>
            {user && (
              <>
                <Button
                  size="sm"
                  onClick={() => setComposerOpen(true)}
                  className="hidden sm:flex"
                >
                  <Plus className="mr-2 h-4 w-4" />
                  New Post
                </Button>
                <Button
                  size="sm"
                  onClick={() => setComposerOpen(true)}
                  className="sm:hidden"
                >
                  <Plus className="h-4 w-4" />
                </Button>
                <NotificationMenu />
                <UserMenu />
              </>
            )}
          </div>
        </div>
      </header>

      {/* Main Feed */}
      <main className="container max-w-2xl px-4 py-8">
        {/* T015: Quick Post Form for logged-in users (hidden on mobile) */}
        {user && (
          <div className="mb-6 hidden sm:block">
            <QuickPostForm />
          </div>
        )}

        <FeedList />
      </main>

      {/* Floating Action Button for mobile quick posting */}
      {user && <FloatingActionButton />}

      {/* Post Composer Dialog */}
      <PostComposer open={composerOpen} onOpenChange={setComposerOpen} />
    </div>
  )
}
